import React from 'react';
import CustomModal from '../CustomModal/CustomModal';
import CustomButton from '../CustomButton/CustomButton';

interface CustomConfirmProps {
  isOpen: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => Promise<any>;
  onCancel?: () => Promise<any>;
  isLoading?: boolean;
}

export default function CustomConfirm({
  isOpen,
  setIsOpenModal,
  title = 'Confirmação',
  message = 'Tem certeza?',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  isLoading,
}: CustomConfirmProps) {
  const handleConfirm = async () => {
    await onConfirm?.();
    setIsOpenModal(false);
  };

  const handleCancel = async () => {
    await onCancel?.();
    setIsOpenModal(false);
  };

  return (
    <CustomModal
      modalTitle={title}
      isOpen={isOpen}
      setIsOpenModal={setIsOpenModal}
      fullscreenOnMobile={false}
    >
      <p>{message}</p>

      <div className='d-flex gap-2 mt-2 justify-content-end'>
        <CustomButton
          className='btn btn-secondary'
          type='button'
          handleClick={handleCancel}
          disabled={isLoading}
        >
          {cancelLabel}
        </CustomButton>

        <CustomButton
          className='btn btn-primary'
          type='button'
          handleClick={handleConfirm}
          disabled={isLoading}
        >
          {confirmLabel}
        </CustomButton>
      </div>
    </CustomModal>
  );
}
